module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('div', {
    staticClass: "pg-title-row"
  }, [_c('div', [_c('h1', {
    staticClass: "pg-title"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('p', {
    staticClass: "pg-title-sub"
  }, [_vm._v("Manage banners, audio channels and API environment")])]), _vm._v(" "), _c('router-link', {
    staticClass: "pg-settings-link",
    attrs: {
      "to": "/admin/system-settings",
      "title": "System Settings"
    }
  }, [_c('svg', {
    attrs: {
      "width": "15",
      "height": "15",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06A1.65 1.65 0 004.6 9a1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06A1.65 1.65 0 009 4.6a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z"
    }
  })]), _vm._v("\n      System Settings\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bn-card"
  }, [_c('div', {
    staticClass: "bn-header"
  }, [_c('span', {
    staticClass: "bn-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "3",
      "width": "18",
      "height": "18",
      "rx": "2",
      "ry": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "8.5",
      "cy": "8.5",
      "r": "1.5"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "21 15 16 10 5 21"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "bn-title"
  }, [_vm._v("Banners")]), _vm._v(" "), _c('p', {
    staticClass: "bn-subtitle"
  }, [_vm._v("Manage promotional banners displayed in the mobile app")])]), _vm._v(" "), _c('button', {
    staticClass: "bn-add-btn",
    attrs: {
      "title": "Add banner"
    },
    on: {
      "click": function($event) {
        return _vm.showBannerModal('Add')
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 5v14M5 12h14"
    }
  })]), _vm._v("\n        Add Banner\n      ")])]), _vm._v(" "), (_vm.bannersLoading) ? _c('div', {
    staticClass: "bn-grid"
  }, _vm._l((3), function(n) {
    return _c('div', {
      key: 'sk-' + n,
      staticClass: "bn-skeleton"
    }, [_c('div', {
      staticClass: "bn-sk-header"
    }, [_c('div', {
      staticClass: "bn-sk-badge sk-shimmer"
    }), _vm._v(" "), _c('div', {
      staticClass: "bn-sk-actions"
    }, [_c('div', {
      staticClass: "bn-sk-btn sk-shimmer"
    }), _vm._v(" "), _c('div', {
      staticClass: "bn-sk-btn sk-shimmer"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "bn-sk-image sk-shimmer"
    })])
  }), 0) : _c('div', {
    staticClass: "bn-grid"
  }, [_vm._l((_vm.bannerList), function(Banner) {
    return _c('div', {
      key: Banner.id,
      staticClass: "bn-item"
    }, [_c('div', {
      staticClass: "bn-item-header"
    }, [_c('span', {
      staticClass: "bn-type-badge"
    }, [_vm._v(_vm._s(Banner.Type))]), _vm._v(" "), _c('div', {
      staticClass: "bn-actions"
    }, [_c('button', {
      staticClass: "bn-action-btn",
      attrs: {
        "title": "Edit banner"
      },
      on: {
        "click": function($event) {
          return _vm.showBannerModal('Edit', Banner)
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "13",
        "height": "13",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
      }
    }), _c('path', {
      attrs: {
        "d": "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
      }
    })])]), _vm._v(" "), _c('button', {
      staticClass: "bn-action-btn bn-action-btn--delete",
      attrs: {
        "title": "Delete banner"
      },
      on: {
        "click": function($event) {
          return _vm.confirmDeleteBanner(Banner)
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "13",
        "height": "13",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('polyline', {
      attrs: {
        "points": "3 6 5 6 21 6"
      }
    }), _c('path', {
      attrs: {
        "d": "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"
      }
    }), _c('path', {
      attrs: {
        "d": "M10 11v6M14 11v6"
      }
    }), _c('path', {
      attrs: {
        "d": "M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"
      }
    })])])])]), _vm._v(" "), _c('div', {
      staticClass: "bn-image-wrap"
    }, [_c('img', {
      staticClass: "bn-image",
      attrs: {
        "src": Banner.ImageUrl
      }
    })])])
  }), _vm._v(" "), (!_vm.bannerList || _vm.bannerList.length === 0) ? _c('div', {
    staticClass: "bn-empty"
  }, [_c('svg', {
    attrs: {
      "width": "32",
      "height": "32",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "#c8c8d8",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "3",
      "width": "18",
      "height": "18",
      "rx": "2"
    }
  }), _c('circle', {
    attrs: {
      "cx": "8.5",
      "cy": "8.5",
      "r": "1.5"
    }
  }), _c('polyline', {
    attrs: {
      "points": "21 15 16 10 5 21"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("No banners yet. Click "), _c('strong', [_vm._v("Add Banner")]), _vm._v(" to create one.")])]) : _vm._e()], 2), _vm._v(" "), _c('add-edit-banner', {
    attrs: {
      "show": _vm.showAddEditBannerModal,
      "type": _vm.bannerOpr,
      "bannerData": _vm.bannerData
    },
    on: {
      "saved": _vm.onSaved,
      "closed": _vm.onClosed
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ac-card"
  }, [_c('div', {
    staticClass: "ac-header"
  }, [_c('span', {
    staticClass: "ac-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.07 4.93a10 10 0 0 1 0 14.14"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.54 8.46a5 5 0 0 1 0 7.07"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "ac-title"
  }, [_vm._v("Audio Channels")]), _vm._v(" "), _c('p', {
    staticClass: "ac-subtitle"
  }, [_vm._v("Configure live stream URLs for channels A–D. The mobile app selects the best available channel.")])])]), _vm._v(" "), _c('div', {
    staticClass: "ac-grid"
  }, [_c('div', {
    staticClass: "ac-col"
  }, _vm._l(([{
      key: 'A',
      saved: _vm.audioChannelA,
      error: _vm.linkAError
    },
    {
      key: 'B',
      saved: _vm.audioChannelB,
      error: _vm.linkBError
    }
  ]), function(ch) {
    return _c('div', {
      key: ch.key,
      staticClass: "ac-channel-row"
    }, [_c('div', {
      staticClass: "ac-row-label"
    }, [_vm._v("Channel " + _vm._s(ch.key))]), _vm._v(" "), _c('div', {
      staticClass: "ac-row-body"
    }, [_c('div', {
      staticClass: "ac-input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.$data['channelLink' + ch.key]),
        expression: "$data['channelLink' + ch.key]"
      }],
      staticClass: "ac-input",
      attrs: {
        "type": "text",
        "name": 'channelLink' + ch.key,
        "placeholder": 'Stream URL for Channel ' + ch.key
      },
      domProps: {
        "value": (_vm.$data['channelLink' + ch.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.$data, 'channelLink' + ch.key, $event.target.value)
        }
      }
    }), _vm._v(" "), (ch.key === 'A') ? _c('button', {
      staticClass: "ac-add-btn",
      on: {
        "click": function($event) {
          return _vm.onAddChannelA()
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "13",
        "height": "13",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2.2",
        "stroke-linecap": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M5 12h14M12 5l7 7-7 7"
      }
    })]), _vm._v("\n              Save\n            ")]) : _c('button', {
      staticClass: "ac-add-btn",
      on: {
        "click": function($event) {
          return _vm.onAddChannelB()
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "13",
        "height": "13",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2.2",
        "stroke-linecap": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M5 12h14M12 5l7 7-7 7"
      }
    })]), _vm._v("\n              Save\n            ")])]), _vm._v(" "), (ch.error) ? _c('div', {
      staticClass: "ac-error"
    }, [_vm._v(_vm._s(ch.error))]) : _vm._e(), _vm._v(" "), (ch.saved) ? _c('div', {
      staticClass: "ac-url-row"
    }, [_c('span', {
      staticClass: "ac-url-badge"
    }, [_vm._v("Live")]), _vm._v(" "), _c('a', {
      staticClass: "ac-url-text",
      attrs: {
        "href": ch.saved,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(ch.saved))]), _vm._v(" "), _c('button', {
      staticClass: "ac-play-btn",
      attrs: {
        "title": _vm.playingChannel === ch.key ? 'Stop' : 'Play channel ' + ch.key
      },
      on: {
        "click": function($event) {
          return _vm.playChannel(ch.saved, ch.key)
        }
      }
    }, [(_vm.playingChannel !== ch.key) ? _c('svg', {
      attrs: {
        "width": "10",
        "height": "10",
        "viewBox": "0 0 12 12",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "d": "M2 1.5l9 4.5-9 4.5V1.5z"
      }
    })]) : _c('svg', {
      attrs: {
        "width": "10",
        "height": "10",
        "viewBox": "0 0 12 12",
        "fill": "currentColor"
      }
    }, [_c('rect', {
      attrs: {
        "x": "2",
        "y": "1.5",
        "width": "3",
        "height": "9",
        "rx": "1"
      }
    }), _c('rect', {
      attrs: {
        "x": "7",
        "y": "1.5",
        "width": "3",
        "height": "9",
        "rx": "1"
      }
    })])])]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ac-col-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ac-col"
  }, _vm._l(([{
      key: 'C',
      saved: _vm.audioChannelC,
      error: _vm.linkCError
    },
    {
      key: 'D',
      saved: _vm.audioChannelD,
      error: _vm.linkDError
    }
  ]), function(ch) {
    return _c('div', {
      key: ch.key,
      staticClass: "ac-channel-row"
    }, [_c('div', {
      staticClass: "ac-row-label"
    }, [_vm._v("Channel " + _vm._s(ch.key))]), _vm._v(" "), _c('div', {
      staticClass: "ac-row-body"
    }, [_c('div', {
      staticClass: "ac-input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.$data['channelLink' + ch.key]),
        expression: "$data['channelLink' + ch.key]"
      }],
      staticClass: "ac-input",
      attrs: {
        "type": "text",
        "name": 'channelLink' + ch.key,
        "placeholder": 'Stream URL for Channel ' + ch.key
      },
      domProps: {
        "value": (_vm.$data['channelLink' + ch.key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.$data, 'channelLink' + ch.key, $event.target.value)
        }
      }
    }), _vm._v(" "), (ch.key === 'C') ? _c('button', {
      staticClass: "ac-add-btn",
      on: {
        "click": function($event) {
          return _vm.onAddChannelC()
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "13",
        "height": "13",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2.2",
        "stroke-linecap": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M5 12h14M12 5l7 7-7 7"
      }
    })]), _vm._v("\n              Save\n            ")]) : _c('button', {
      staticClass: "ac-add-btn",
      on: {
        "click": function($event) {
          return _vm.onAddChannelD()
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "13",
        "height": "13",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2.2",
        "stroke-linecap": "round"
      }
    }, [_c('path', {
      attrs: {
        "d": "M5 12h14M12 5l7 7-7 7"
      }
    })]), _vm._v("\n              Save\n            ")])]), _vm._v(" "), (ch.error) ? _c('div', {
      staticClass: "ac-error"
    }, [_vm._v(_vm._s(ch.error))]) : _vm._e(), _vm._v(" "), (ch.saved) ? _c('div', {
      staticClass: "ac-url-row"
    }, [_c('span', {
      staticClass: "ac-url-badge"
    }, [_vm._v("Live")]), _vm._v(" "), _c('a', {
      staticClass: "ac-url-text",
      attrs: {
        "href": ch.saved,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(ch.saved))]), _vm._v(" "), _c('button', {
      staticClass: "ac-play-btn",
      attrs: {
        "title": _vm.playingChannel === ch.key ? 'Stop' : 'Play channel ' + ch.key
      },
      on: {
        "click": function($event) {
          return _vm.playChannel(ch.saved, ch.key)
        }
      }
    }, [(_vm.playingChannel !== ch.key) ? _c('svg', {
      attrs: {
        "width": "10",
        "height": "10",
        "viewBox": "0 0 12 12",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "d": "M2 1.5l9 4.5-9 4.5V1.5z"
      }
    })]) : _c('svg', {
      attrs: {
        "width": "10",
        "height": "10",
        "viewBox": "0 0 12 12",
        "fill": "currentColor"
      }
    }, [_c('rect', {
      attrs: {
        "x": "2",
        "y": "1.5",
        "width": "3",
        "height": "9",
        "rx": "1"
      }
    }), _c('rect', {
      attrs: {
        "x": "7",
        "y": "1.5",
        "width": "3",
        "height": "9",
        "rx": "1"
      }
    })])])]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "ab-card"
  }, [_c('div', {
    staticClass: "ab-header"
  }, [_c('span', {
    staticClass: "ab-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "8",
      "r": "4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 21a8 8 0 0 1 16 0"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ab-header-text"
  }, [_c('h2', {
    staticClass: "ab-title"
  }, [_vm._v("Action Button")]), _vm._v(" "), _c('p', {
    staticClass: "ab-subtitle"
  }, [_vm._v("Configure the circular image and tap-through URL shown in the mobile app")])]), _vm._v(" "), _c('div', {
    staticClass: "ab-header-actions"
  }, [_c('button', {
    staticClass: "ab-clear-btn",
    attrs: {
      "disabled": !_vm.hasActionButtonData || _vm.actionButtonSaving || _vm.actionButtonUploading || _vm.actionButtonLoading
    },
    on: {
      "click": _vm.clearActionButtonSettings
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 6h18"
    }
  }), _c('path', {
    attrs: {
      "d": "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
    }
  }), _c('path', {
    attrs: {
      "d": "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"
    }
  }), _c('path', {
    attrs: {
      "d": "M10 11v6M14 11v6"
    }
  })]), _vm._v("\n        Clear\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "ab-save-btn",
    attrs: {
      "disabled": _vm.actionButtonSaving || _vm.actionButtonUploading || _vm.actionButtonLoading
    },
    on: {
      "click": _vm.saveActionButtonSettings
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
    }
  }), _c('polyline', {
    attrs: {
      "points": "17 21 17 13 7 13 7 21"
    }
  }), _c('polyline', {
    attrs: {
      "points": "7 3 7 8 15 8"
    }
  })]), _vm._v("\n        " + _vm._s(_vm.actionButtonSaving ? 'Saving...' : 'Save') + "\n      ")])])]), _vm._v(" "), (_vm.actionButtonLoading) ? _c('div', {
    staticClass: "ab-loading-grid"
  }, [_c('div', {
    staticClass: "ab-preview-skeleton sk-shimmer"
  }), _vm._v(" "), _c('div', {
    staticClass: "ab-loading-fields"
  }, [_c('div', {
    staticClass: "ab-sk-line ab-sk-line--wide sk-shimmer"
  }), _vm._v(" "), _c('div', {
    staticClass: "ab-sk-line sk-shimmer"
  })])]) : _c('div', {
    staticClass: "ab-body"
  }, [_c('div', {
    staticClass: "ab-preview-col"
  }, [_c('div', {
    staticClass: "ab-preview"
  }, [(_vm.actionButtonPreviewSrc) ? _c('img', {
    staticClass: "ab-preview-img",
    attrs: {
      "src": _vm.actionButtonPreviewSrc,
      "alt": "Action button preview"
    }
  }) : _c('svg', {
    attrs: {
      "width": "22",
      "height": "22",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "8",
      "r": "4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4 21a8 8 0 0 1 16 0"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "ab-preview-label"
  }, [_vm._v("Preview")])]), _vm._v(" "), _c('div', {
    staticClass: "ab-fields"
  }, [_c('div', {
    staticClass: "ab-upload-row"
  }, [_c('label', {
    staticClass: "ab-file-label"
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "17 8 12 3 7 8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "3",
      "x2": "12",
      "y2": "15"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.actionButtonFile ? _vm.actionButtonFile.name : 'Choose image (.jpg, .png, .webp)'))]), _vm._v(" "), _c('input', {
    staticClass: "ab-file-hidden",
    attrs: {
      "type": "file",
      "accept": "image/jpeg,image/png,image/webp,image/gif"
    },
    on: {
      "change": _vm.onActionButtonFileSelect
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "ab-upload-btn",
    attrs: {
      "disabled": !_vm.actionButtonFile || _vm.actionButtonUploading
    },
    on: {
      "click": _vm.uploadActionButtonImage
    }
  }, [(!_vm.actionButtonUploading) ? _c('span', [_vm._v("Upload")]) : _c('span', [_vm._v(_vm._s(_vm.actionButtonUploadPct) + "%")])])]), _vm._v(" "), (_vm.actionButtonUploading) ? _c('progress', {
    staticClass: "ab-progress",
    attrs: {
      "max": "100"
    },
    domProps: {
      "value": _vm.actionButtonUploadPct
    }
  }) : _vm._e(), _vm._v(" "), (_vm.actionButtonImageError) ? _c('div', {
    staticClass: "ab-alert ab-alert--error"
  }, [_vm._v(_vm._s(_vm.actionButtonImageError))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ab-url-field"
  }, [_c('label', {
    staticClass: "ab-label"
  }, [_vm._v("Target URL")]), _vm._v(" "), _c('div', {
    staticClass: "ab-input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actionButtonUrl),
      expression: "actionButtonUrl"
    }],
    staticClass: "ab-input",
    attrs: {
      "type": "text",
      "placeholder": "https://example.com/action"
    },
    domProps: {
      "value": (_vm.actionButtonUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.actionButtonUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ab-open-btn",
    attrs: {
      "disabled": !_vm.isStrictHttpUrl(_vm.actionButtonUrl),
      "title": "Open URL in new tab"
    },
    on: {
      "click": _vm.openActionButtonUrl
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
    }
  }), _c('polyline', {
    attrs: {
      "points": "15 3 21 3 21 9"
    }
  }), _c('line', {
    attrs: {
      "x1": "10",
      "y1": "14",
      "x2": "21",
      "y2": "3"
    }
  })])])]), _vm._v(" "), (_vm.actionButtonUrlError) ? _c('div', {
    staticClass: "ab-field-error"
  }, [_vm._v(_vm._s(_vm.actionButtonUrlError))]) : _vm._e()]), _vm._v(" "), (_vm.actionButtonImageUrl) ? _c('div', {
    staticClass: "ab-url-row"
  }, [_c('span', {
    staticClass: "ab-url-badge"
  }, [_vm._v("Image")]), _vm._v(" "), _c('a', {
    staticClass: "ab-url-text",
    attrs: {
      "href": _vm.actionButtonImageUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.actionButtonImageUrl))])]) : _vm._e(), _vm._v(" "), (!_vm.hasActionButtonData) ? _c('div', {
    staticClass: "ab-empty-note"
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 8v4M12 16h.01"
    }
  })]), _vm._v("\n        No action button is configured. The mobile app will not show this button.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.actionButtonSaveSuccess) ? _c('div', {
    staticClass: "ab-success-badge"
  }, [_c('svg', {
    attrs: {
      "width": "12",
      "height": "12",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })]), _vm._v("\n        " + _vm._s(_vm.actionButtonSuccessMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.actionButtonSaveError) ? _c('div', {
    staticClass: "ab-alert ab-alert--error"
  }, [_vm._v(_vm._s(_vm.actionButtonSaveError))]) : _vm._e()])])]), _vm._v(" "), _c('image-crop-preview-modal', {
    attrs: {
      "modal-name": "actionButtonCropModal",
      "show": _vm.actionButtonCropModalVisible,
      "source-url": _vm.actionButtonCropSourceUrl,
      "file-name": _vm.actionButtonCropFileName,
      "aspect-ratio": 1,
      "output-width": 600,
      "output-height": 600,
      "title": "Preview Action Button",
      "subtitle": "Crop the circular image area before upload"
    },
    on: {
      "cropped": _vm.onActionButtonImageCropped,
      "closed": _vm.onActionButtonCropClosed
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom-row"
  }, [_c('div', {
    staticClass: "fbc-card"
  }, [_c('div', {
    staticClass: "fbc-header"
  }, [_c('div', {
    staticClass: "fbc-header-left"
  }, [_c('span', {
    staticClass: "fbc-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 18V5l12-2v13",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "6",
      "cy": "18",
      "r": "3",
      "stroke": "currentColor",
      "stroke-width": "1.8"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "18",
      "cy": "16",
      "r": "3",
      "stroke": "currentColor",
      "stroke-width": "1.8"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "fbc-title"
  }, [_vm._v("Default Fallback Channel")]), _vm._v(" "), _c('p', {
    staticClass: "fbc-subtitle"
  }, [_vm._v("Used by the mobile app when no race-specific audio channel is assigned")])])])]), _vm._v(" "), (_vm.fallbackChannelUrl) ? _c('div', {
    staticClass: "fbc-url-row"
  }, [_c('span', {
    staticClass: "fbc-url-label"
  }, [_vm._v("Active")]), _vm._v(" "), _c('a', {
    staticClass: "fbc-url-text",
    attrs: {
      "href": _vm.fallbackChannelUrl,
      "target": "blank"
    }
  }, [_vm._v(_vm._s(_vm.fallbackChannelUrl))]), _vm._v(" "), _c('button', {
    staticClass: "fbc-play-btn",
    attrs: {
      "title": _vm.playingChannel === 'FALLBACK' ? 'Stop' : 'Play'
    },
    on: {
      "click": function($event) {
        return _vm.playChannel(_vm.fallbackChannelUrl, 'FALLBACK')
      }
    }
  }, [(_vm.playingChannel !== 'FALLBACK') ? _c('svg', {
    attrs: {
      "width": "10",
      "height": "10",
      "viewBox": "0 0 12 12",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2 1.5l9 4.5-9 4.5V1.5z"
    }
  })]) : _c('svg', {
    attrs: {
      "width": "10",
      "height": "10",
      "viewBox": "0 0 12 12",
      "fill": "currentColor"
    }
  }, [_c('rect', {
    attrs: {
      "x": "2",
      "y": "1.5",
      "width": "3",
      "height": "9",
      "rx": "1"
    }
  }), _c('rect', {
    attrs: {
      "x": "7",
      "y": "1.5",
      "width": "3",
      "height": "9",
      "rx": "1"
    }
  })])])]) : _c('div', {
    staticClass: "fbc-empty"
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.5"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 8v4M12 16h.01"
    }
  })]), _vm._v("\n      No fallback URL saved\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "fbc-upload-area"
  }, [_c('label', {
    staticClass: "fbc-file-label"
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "17 8 12 3 7 8"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "3",
      "x2": "12",
      "y2": "15"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fallbackFile ? _vm.fallbackFile.name : 'Choose audio file (.mp3, .m4a, .aac)'))]), _vm._v(" "), _c('input', {
    staticClass: "fbc-file-hidden",
    attrs: {
      "type": "file",
      "accept": "audio/mpeg,audio/mp4,audio/aac,.mp3,.m4a,.aac"
    },
    on: {
      "change": _vm.onFallbackFileSelect
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "fbc-upload-btn",
    attrs: {
      "disabled": !_vm.fallbackFile || _vm.fallbackUploading
    },
    on: {
      "click": _vm.onUploadFallback
    }
  }, [(!_vm.fallbackUploading) ? _c('span', [_vm._v("Upload")]) : _c('span', {
    staticClass: "fbc-uploading-text"
  }, [_vm._v(_vm._s(_vm.fallbackUploadPct) + "%")])])]), _vm._v(" "), (_vm.fallbackUploading) ? _c('div', {
    staticClass: "fbc-progress"
  }, [_c('div', {
    staticClass: "fbc-progress-bar",
    style: ({
      width: _vm.fallbackUploadPct + '%'
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.fallbackUploadError) ? _c('div', {
    staticClass: "fbc-alert fbc-alert--error"
  }, [_vm._v(_vm._s(_vm.fallbackUploadError))]) : _vm._e(), _vm._v(" "), (_vm.fallbackSaveSuccess) ? _c('div', {
    staticClass: "fbc-success-badge fbc-save-inline"
  }, [_c('svg', {
    attrs: {
      "width": "12",
      "height": "12",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })]), _vm._v("\n      Uploaded & saved to Firebase\n    ")]) : _vm._e(), _vm._v(" "), (_vm.fallbackSaveError) ? _c('span', {
    staticClass: "fbc-alert fbc-alert--inline"
  }, [_vm._v(_vm._s(_vm.fallbackSaveError))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mode-card"
  }, [_c('div', {
    staticClass: "mode-header"
  }, [_c('span', {
    staticClass: "mode-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mode-header-text"
  }, [_c('h2', {
    staticClass: "mode-title"
  }, [_vm._v("API Environment")]), _vm._v(" "), _c('p', {
    staticClass: "mode-subtitle"
  }, [_vm._v("Switch between Live and Staging environments")])])]), _vm._v(" "), _c('div', {
    staticClass: "mode-toggle-row"
  }, [_c('lv-toggle', {
    on: {
      "change": function($event) {
        return _vm.onToggle()
      }
    },
    model: {
      value: (_vm.alert),
      callback: function($$v) {
        _vm.alert = $$v
      },
      expression: "alert"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mode-env-label",
    class: _vm.alert ? 'mode-env-label--staging' : 'mode-env-label--live'
  }, [_vm._v("\n        " + _vm._s(_vm.alert ? 'Staging' : 'Live') + "\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mode-warning"
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 8v4M12 16h.01"
    }
  })]), _vm._v("\n      Do not switch API environment while a live run is happening\n    ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc01d5a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/Settings.vue
// module id = 1753
// module chunks = 2